export default "/_next/static/images/badge-modal-f82f6562913e033511ba55a84f74e146.png";